(function () {
  /* Contact LA — "< Back" + × chrome aligned with eyeglasses flow (ciw-la-gusa-back.js) */
  var pollId = null;
  var modalObserver = null;
  var resizeHandler = null;

  function isContactHost() {
    if (window.ciwLaHostApi && window.ciwLaHostApi.isContactLens) {
      return window.ciwLaHostApi.isContactLens();
    }
    return !!document.querySelector('.cl-section');
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getModal() {
    return document.getElementById('lensadvizor-prescription-modal');
  }

  function getNativeBack(modal) {
    if (!modal) return null;
    return modal.querySelector('.la-steeper-back');
  }

  function hideNativeBack(back) {
    if (!back) return;
    back.classList.add('ciw-la-contact-back-native');
    back.setAttribute('aria-hidden', 'true');
  }

  function restoreNativeBack(back) {
    if (!back) return;
    back.classList.remove('ciw-la-contact-back-native');
    back.removeAttribute('aria-hidden');
  }

  function removeCustomBack(modal) {
    if (!modal) return;
    var custom = modal.querySelector(':scope > .ciw-la-contact-back-btn');
    if (custom) custom.remove();
  }

  function getStepTitleElement(modal) {
    var contentBody = modal && modal.querySelector('.la-prescription-modal-content-body');
    if (!contentBody) return null;

    var candidates = contentBody.querySelectorAll(
      '.la-wrapper-heading h3, #la_prescriptionSelect_title, .ciw-la-manual-rx-heading__title'
    );

    for (var i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      if (!candidate || candidate.closest('[hidden], .ciw-la-manual-rx-hidden')) {
        continue;
      }

      var rect = candidate.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        return candidate;
      }
    }

    return null;
  }

  function getFallbackLeft(modal, bodyRect, isMobile) {
    var gutter = isMobile ? 16 : 18;

    if (
      !isMobile &&
      (modal.querySelector('.la-prescription-wrapper:not(form)') ||
        modal.querySelector('#la-prescription-form.ciw-la-contact-rx-form--mobile') ||
        modal.querySelector('#la-prescription-form.ciw-la-contact-upload-form--mobile') ||
        modal.querySelector('.la-quantity-selector-wrapper') ||
        modal.querySelector('.la-choose-prescription-wrapper.la-render-review'))
    ) {
      gutter = 35;
    }

    return bodyRect.left + gutter;
  }

  function getModalClose() {
    var header = document.getElementById('la-prescription-modal-header');
    if (header) {
      var closeInHeader = header.querySelector('.la-prescription-modal-close');
      if (closeInHeader) {
        return closeInHeader;
      }
    }

    var modal = getModal();
    return modal ? modal.querySelector('.la-prescription-modal-close') : null;
  }

  function restoreClosePosition() {
    var close = getModalClose();
    if (close) {
      close.style.removeProperty('top');
      close.style.removeProperty('left');
      close.style.removeProperty('right');
      close.style.removeProperty('position');
      close.style.removeProperty('z-index');
    }
  }

  function restoreCloseChrome() {
    var close = getModalClose();
    if (!close) {
      return;
    }

    close.classList.remove('ciw-la-contact-close-btn');
    close.style.removeProperty('display');
    restoreClosePosition();
  }

  function syncCloseChrome() {
    if (isMobileViewport() && !isContactHost()) {
      restoreCloseChrome();
      return;
    }

    var close = getModalClose();
    if (!close) {
      return;
    }

    close.classList.add('ciw-la-contact-close-btn');
    close.style.setProperty('display', 'flex', 'important');
  }

  function ensureCloseOnModalRoot(modal, close) {
    if (modal && close && close.parentElement !== modal) {
      modal.appendChild(close);
    }
  }

  function getMobileNavBandTop(modal) {
    var header = document.getElementById('la-prescription-modal-header');
    if (!header) return null;

    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var bandOffset = Math.max(8, vh * 0.04 - 20);
    return header.getBoundingClientRect().bottom + bandOffset;
  }

  function getStepContentRight(modal, contentBody) {
    var titleEl = getStepTitleElement(modal);
    if (titleEl) {
      var titleRect = titleEl.getBoundingClientRect();
      if (titleRect.width > 0) {
        return titleRect.right;
      }
    }

    if (!contentBody) {
      return null;
    }

    var bodyRect = contentBody.getBoundingClientRect();
    if (bodyRect.width <= 0) {
      return null;
    }

    var paddingRight = parseFloat(window.getComputedStyle(contentBody).paddingRight) || 0;
    return bodyRect.right - paddingRight;
  }

  function positionMobileCloseAlign(backEl, backTop, modal, contentBody) {
    if (!isMobileViewport() || !isContactHost()) {
      return;
    }

    var close = getModalClose();
    if (!close) {
      return;
    }

    ensureCloseOnModalRoot(modal, close);
    syncCloseChrome();

    var navTop = typeof backTop === 'number' ? backTop : getMobileNavBandTop(modal);
    if (navTop === null) {
      return;
    }

    var refHeight = backEl ? backEl.getBoundingClientRect().height || 34 : 34;
    var closeHeight = close.getBoundingClientRect().height || 34;
    var alignedTop = navTop + (refHeight - closeHeight) / 2;
    var contentRight = getStepContentRight(modal, contentBody);

    close.style.setProperty('position', 'fixed', 'important');
    close.style.setProperty('top', alignedTop + 'px', 'important');
    close.style.setProperty('z-index', '100003', 'important');

    if (contentRight !== null) {
      var closeWidth = close.getBoundingClientRect().width || 34;
      close.style.setProperty('left', contentRight - closeWidth + 'px', 'important');
      close.style.setProperty('right', 'auto', 'important');
    } else {
      close.style.removeProperty('left');
      close.style.setProperty('right', '16px', 'important');
    }
  }

  function getDesktopCloseTop(modal, backEl, backTop, closeHeight) {
    var refHeight = backEl ? backEl.getBoundingClientRect().height || 20 : 20;

    if (backEl && typeof backTop === 'number') {
      return backTop + (refHeight - closeHeight) / 2;
    }

    var header = document.getElementById('la-prescription-modal-header');
    if (!header) {
      return null;
    }

    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var bandOffset = Math.max(8, vh * 0.04 - 20);
    var headerRect = header.getBoundingClientRect();
    var top = headerRect.bottom + bandOffset;
    var titleEl = getStepTitleElement(modal);

    if (titleEl) {
      var titleRect = titleEl.getBoundingClientRect();
      top = Math.max(headerRect.bottom + 4, titleRect.top - refHeight - 20);
    }

    return top + (refHeight - closeHeight) / 2;
  }

  function positionDesktopCloseAlign(backEl, backTop, modal, contentBody) {
    if (isMobileViewport()) {
      return;
    }

    var close = getModalClose();
    if (!close) {
      return;
    }

    syncCloseChrome();

    var closeHeight = close.getBoundingClientRect().height || 36;
    var alignedTop = getDesktopCloseTop(modal, backEl, backTop, closeHeight);
    if (alignedTop === null) {
      return;
    }

    var contentRight = getStepContentRight(modal, contentBody);

    close.style.setProperty('top', alignedTop + 'px', 'important');

    if (contentRight !== null) {
      var closeWidth = close.getBoundingClientRect().width || 36;
      close.style.setProperty('left', contentRight - closeWidth + 'px', 'important');
      close.style.setProperty('right', 'auto', 'important');
    }
  }

  function positionContactBack(custom, modal) {
    var header = document.getElementById('la-prescription-modal-header');
    var contentBody = modal.querySelector('.la-prescription-modal-content-body');
    if (!custom || !header) return;

    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var bandOffset = Math.max(8, vh * 0.04 - 20);
    var headerRect = header.getBoundingClientRect();
    var bandTop = headerRect.bottom + bandOffset;
    var top = bandTop;

    var isMobile = isMobileViewport();
    var titleEl = getStepTitleElement(modal);

    if (isMobile) {
      /* Mobile — back sits in the header band row; title-based top is desktop-only. */
    } else if (titleEl) {
      var titleRect = titleEl.getBoundingClientRect();
      var backHeight = custom.getBoundingClientRect().height || 20;
      top = Math.max(headerRect.bottom + 4, titleRect.top - backHeight - 20);
    }

    custom.style.setProperty('top', top + 'px', 'important');

    var left = 18;

    if (contentBody) {
      var bodyRect = contentBody.getBoundingClientRect();
      if (bodyRect.width > 0) {
        if (titleEl) {
          left = titleEl.getBoundingClientRect().left;
        } else {
          left = getFallbackLeft(modal, bodyRect, isMobile);
        }
      }
    }

    custom.style.setProperty('left', left + 'px', 'important');

    if (isMobile) {
      positionMobileCloseAlign(custom, top, modal, contentBody);
    } else {
      positionDesktopCloseAlign(custom, top, modal, contentBody);
    }
  }

  function ensureCustomBack(modal, nativeBack) {
    var custom = modal.querySelector(':scope > .ciw-la-contact-back-btn');
    if (!custom) {
      custom = document.createElement('button');
      custom.type = 'button';
      custom.className = 'ciw-la-contact-back-btn';
      custom.textContent = '< Back';
      custom.setAttribute('aria-label', 'Back');
      custom.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var liveNativeBack = getNativeBack(getModal());
        if (liveNativeBack && !liveNativeBack.disabled) {
          liveNativeBack.click();
        }
      });
      modal.appendChild(custom);
    }
    return custom;
  }

  function syncContactBack() {
    if (!isContactHost() || !document.body.classList.contains('la-modal-open')) {
      teardownContactBack();
      return;
    }

    var modal = getModal();
    if (!modal) return;

    var contentBody = modal.querySelector('.la-prescription-modal-content-body');

    syncCloseChrome();

    var nativeBack = getNativeBack(modal);
    if (!nativeBack || nativeBack.disabled) {
      restoreNativeBack(nativeBack);
      removeCustomBack(modal);
      if (isMobileViewport()) {
        positionMobileCloseAlign(null, getMobileNavBandTop(modal), modal, contentBody);
      } else {
        positionDesktopCloseAlign(null, null, modal, contentBody);
      }
      return;
    }

    hideNativeBack(nativeBack);
    var custom = ensureCustomBack(modal, nativeBack);
    positionContactBack(custom, modal);
    startObserve();
  }

  function stopPoll() {
    if (!pollId) return;
    window.clearInterval(pollId);
    pollId = null;
  }

  function startPoll() {
    if (pollId) return;
    pollId = window.setInterval(syncContactBack, 250);
  }

  function stopObserve() {
    if (!modalObserver) return;
    modalObserver.disconnect();
    modalObserver = null;
  }

  function startObserve() {
    if (modalObserver) return;
    var modal = getModal();
    if (!modal || typeof MutationObserver === 'undefined') return;

    modalObserver = new MutationObserver(function () {
      syncContactBack();
    });
    modalObserver.observe(modal, { childList: true, subtree: true });
  }

  function teardownContactBack() {
    var modal = getModal();
    restoreNativeBack(getNativeBack(modal));
    removeCustomBack(modal);
    restoreCloseChrome();
    stopPoll();
    stopObserve();
    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler);
      resizeHandler = null;
    }
  }

  function onModalOpen() {
    window.setTimeout(syncContactBack, 0);
    window.setTimeout(syncContactBack, 150);
    startPoll();
    startObserve();
    if (!resizeHandler) {
      resizeHandler = function () {
        syncContactBack();
      };
      window.addEventListener('resize', resizeHandler);
    }
  }

  function bind() {
    if (!isContactHost()) return;

    document.addEventListener('LensAdvizor:selectLensModal:open', onModalOpen);
    document.addEventListener('LensAdvizor:selectLensModal:close', teardownContactBack);

    [
      'LensAdvizor:render:submissionMethods',
      'LensAdvizor:render:manualEntryForm',
      'LensAdvizor:render:contactLensForm',
      'LensAdvizor:render:uploadForm',
      'LensAdvizor:review:rendered',
      'LensAdvizor:component:DidMount',
      'ciw-la-contact-rx:enhanced',
      'ciw-la-contact-rx:footer-sync',
      'ciw-la-contact-upload:enhanced'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        window.setTimeout(syncContactBack, 0);
        window.setTimeout(syncContactBack, 150);
      });
    });

    if (document.body.classList.contains('la-modal-open')) {
      onModalOpen();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
